<template>
    <Carousel
        v-if="sliders.length > 0"
        :autoplay="true"
        :autoplayTimeout="7000"
        :autoplayHoverPause="true"
        :perPageCustom="[[200, 1], [660, 2], [1200, 3]]"
        :navigationEnabled="true"
        :paginationEnabled="false"
        :loop="true"
        :scrollPerPage="false"
        :navigationClickTargetSize="mediaDesktop ? 8 : 0"
        :navigationNextLabel="`<i style='font-size: ${carousel.controls.size}; color: ${carousel.controls.color};' class='fas fa-angle-right'></i>`"
        :navigationPrevLabel="`<i style='font-size: ${carousel.controls.size}; color: ${carousel.controls.color};' class='fas fa-angle-left'></i>`"
    >
        <Slide
            v-for="slide in sliders" 
            :key="slide.id"
        >
            <c-slider-rating>
                <div class="slide-informations mb-1">
                    <div class="user-informations">
                        <h3>{{ slide.user_company_name }}</h3>
                        <star-rating 
                            v-model="slide.points"
                            :star-size="15"
                            :show-rating="false"
                            :read-only="true"
                            class="slide-rating"
                            :active-color="stars.color_active"
                            :inactive-color="stars.color_inactive"
                        >
                        </star-rating>
                    </div>
                    <small>{{ slide.pro_name_site }}</small>
                </div>
                <p class="slide-title">{{ slide.title }}</p>         
                <div
                    :id="`slide-comment-${slide.id}`"
                    :class="[
                        'slide-comment',
                        slide.comment.length > 250 ? 'limited' : ''
                    ]"
                >
                    <span>{{ slide.comment }}</span>
                    <p
                        v-if="slide.comment.length > 250"
                        @click.prevent="readMore(`slide-comment-${slide.id}`)"
                        class="read-more-comment"
                    >
                        Leia mais
                    </p>
                </div>             
            </c-slider-rating>
        </Slide>
    </Carousel>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import StarRating from 'vue-star-rating'
import { CSliderRating } from '../Styles/Template/styled'

export default {
    name: 'CarouselRatings',
    props: {
        ratings: {
            default: '',
            type: String
        }
    },
    components: {
        Carousel,
        Slide,
        StarRating,
        'c-slider-rating': CSliderRating
    },
    data() {
        return {
            sliders: JSON.parse(this.ratings).data,
            primary_color: this.$root.$children[0].theme?.primary_color ?? '#000',
            stars: {
                color_active: this.$root.$children[0].theme?.products?.rating?.star_color_active ?? '#ffd055',
                color_inactive: this.$root.$children[0].theme?.products?.rating?.star_color ?? '#d8d8d8'
            },
            carousel: {
                controls: {
                    color: this.$root.$children[0].theme?.home_page?.carousel?.controls?.color ?? '#000',
                    size: this.$root.$children[0].theme?.home_page?.carousel?.controls?.size ?? '20px'
                }
            },
            mediaDesktop: window.matchMedia('(min-width:992px)').matches
        }
    },
    methods: {
        readMore(id) {
            let comments = document.querySelectorAll('.slide-comment')
            comments.forEach(element => {
                element.classList.add('limited')
            });
            let comment = document.getElementById(id)
            if(comment) {
                comment.classList.remove('limited')
            }
        }
    }
}
</script>